import styled from "styled-components";

// ─────────────────────────────────────────────────────────────────────────────
// Pattern A  —  Two-Column: Text | Image  (and Welcome variant)
// ─────────────────────────────────────────────────────────────────────────────

export const TwoColRow = styled.div`
  display: flex;
  gap: 2.5rem;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const ColText = styled.div`
  flex: 1;
`;

export const ColImage = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    order: -1;
    width: 100%;
  }
`;

export const ColImg = styled.img`
  width: 100%;
  height: auto;
  max-height: 360px;
  object-fit: cover;
  border-radius: 10px;
  display: block;
`;

// ─────────────────────────────────────────────────────────────────────────────
// Pattern B  —  Five-Column Icon Cards  (Why Choose)
// Max-width 1400px, matches the standard PageWrapper width
// ─────────────────────────────────────────────────────────────────────────────

export const WideSection = styled.section`
  max-width: 1400px;
  margin: 0 auto 2.5rem;
  padding: 0 5%;

  @media (max-width: 768px) {
    padding: 0 5%;
  }
`;

export const FiveColRow = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    gap: 1rem;
  }

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const IconCard = styled.div`
  flex: 1 0 16%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.25rem 0.75rem;

  @media (max-width: 900px) {
    flex: 1 0 28%;
  }

  @media (max-width: 520px) {
    flex: 1 0 42%;
  }
`;

export const IconCardImage = styled.img`
  width: 60px;
  height: 60px;
  margin-bottom: 0.85rem;
  border-radius: 50%;
`;

export const IconCardLabel = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  font-family: Montserrat, sans-serif;
  margin-bottom: 0.4rem;
`;

export const IconCardDesc = styled.p`
  font-size: 13px;
  line-height: 1.65;
  color: #3a3a3a;
  font-family: Montserrat, sans-serif;
  margin: 0;
`;

// ─────────────────────────────────────────────────────────────────────────────
// Pattern C  —  Three-Row: Intro / 3-Col Steps / Closing
// Pattern G  —  Four-Row:  Intro / 4-Col Steps / Closing / Image
// ─────────────────────────────────────────────────────────────────────────────

export const ThreeColRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin: 1.5rem 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.25rem;
  }
`;

export const FourColRow = styled.div`
  display: flex;
  gap: 1.25rem;
  margin: 1.5rem 0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const StepCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem 0.75rem;

  @media (max-width: 768px) {
    flex: 1 0 42%;
  }
`;

export const StepCardIcon = styled.img`
  width: 52px;
  height: 52px;
  margin-bottom: 0.75rem;
  border-radius: 50%;
`;

export const StepCardTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
  font-family: Montserrat, sans-serif;
  margin-bottom: 0.35rem;
`;

export const StepCardDesc = styled.p`
  font-size: 13px;
  line-height: 1.65;
  color: #3a3a3a;
  font-family: Montserrat, sans-serif;
  margin: 0;
`;

// ─────────────────────────────────────────────────────────────────────────────
// Pattern D  —  Two-Row: Full-Width Intro / (Bullets | Image)
// ─────────────────────────────────────────────────────────────────────────────

export const TwoColContentRow = styled.div`
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
  margin-top: 1.25rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const ColBullets = styled.div`
  flex: 1;
`;

export const ColImageRight = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    order: -1;
    width: 100%;
  }
`;

// ─────────────────────────────────────────────────────────────────────────────
// Pattern E  —  Three-Row: Intro / 2-Col Service Cards / 2-Col Service Cards
// ─────────────────────────────────────────────────────────────────────────────

export const ServiceCardGrid = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1.25rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.25rem;
  }
`;

export const ServiceCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ServiceCardImg = styled.img`
  width: 100%;
  height: 240px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  margin-bottom: 0.85rem;
`;

export const ServiceCardTitle = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  font-family: Montserrat, sans-serif;
  margin-bottom: 0.35rem;
`;

export const ServiceCardDesc = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #3a3a3a;
  font-family: Montserrat, sans-serif;
  margin: 0;
`;

// ─────────────────────────────────────────────────────────────────────────────
// Pattern F / G  —  Bottom Section Image
// ─────────────────────────────────────────────────────────────────────────────

export const SectionBottomImage = styled.img`
  display: block;
  width: 100%;
  max-width: 640px;
  height: auto;
  border-radius: 10px;
  margin: 1.75rem auto 0;
`;
